module.exports = __webpack_public_path__ + "img/TechGatherStone1_ua.be2227dc.webp";